import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-total-projects',
    imports: [],
    templateUrl: './mp-total-projects.component.html',
    styleUrl: './mp-total-projects.component.scss'
})
export class MpTotalProjectsComponent {}